// @flow
import type Moment from 'moment';
import toISODateString from './toISODateString';

export default function toDateStringArray(dates: Array<Moment>): Array<string> {
  return dates.map(d => toISODateString(d).replace(/-/g, ''));
}
